import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { Skeleton } from '../../../Skeleton'
import {
  BIRDVIEW_CARD_SKELETON_SUBTITLE_WIDTHS,
  BIRDVIEW_CARD_SKELETON_TITLE_WIDTHS,
} from '../BirdviewCard.constants'

import * as styles from './BirdviewCardSkeleton.module.css'

function BirdviewCardSkeleton({
  hasAction = true,
  hasBefore,
  hasMeta = true,
  hasSubtitle = true,
}) {
  return BIRDVIEW_CARD_SKELETON_TITLE_WIDTHS.map((titleWidth, row) => (
    <div className={styles.row} key={row}>
      {hasBefore ? <Skeleton className={styles.before} /> : null}
      <Avatar isLoading size={AVATAR_HEIGHT_24} />
      <div className={styles.main}>
        <Skeleton className={styles.title} style={{ width: titleWidth }} />
        {hasSubtitle ? (
          <Skeleton
            className={styles.subtitle}
            style={{ width: BIRDVIEW_CARD_SKELETON_SUBTITLE_WIDTHS[row] }}
          />
        ) : null}
      </div>
      {hasMeta ? <Skeleton className={styles.meta} /> : null}
      {hasAction ? <Skeleton className={styles.action} /> : null}
    </div>
  ))
}

export default BirdviewCardSkeleton
